import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import DesktopScrollbar from '@root/styles/mixins/desktopScrollbar';

export const StyledContainer = styled.div<{
  $deliveryMode?: 'homeDelivery' | 'pickUpInStore';
  $selectedSlot: boolean;
}>`
  display: flex;
  flex-direction: column;

  padding: ${rem(8)} ${rem(20)} ${rem(8)} ${rem(20)};

  gap: ${rem(8)};

  ${DesktopScrollbar}
`;

export const StyledEmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${rem(50)};
  border-radius: ${rem(4)};
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  cursor: default;
`;
